module.exports = __webpack_public_path__ + "media/its_in_the_way_inst.1f3158a5.mp3";